module.exports = __webpack_public_path__ + "img/MicrosoftDynamics365CRM.bf9ef33e.png";